import Instance from "../../../../Axios";

// New Actions for the app

const GetCredAlocacoes = () => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/alocacoes`)
    .then(({ data }) => {
      dispatch({
        type: "GET_CRED_ALOCACOES",
        payload: data.yData,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredAlocacoes;
